var base = require('settings/teams/team-settings');

Vue.component('spark-team-settings', {
    mixins: [base],

    methods: {
        activateFirstTab() {
            if ($('#customSettings').length) {
                $("#owner").removeClass('active');
                return;
            }

            const tab = $(`${this.pushStateSelector} a[data-toggle="tab"]`).first();

            if (tab.length) {
                tab.tab('show');

                this.broadcastTabChange(tab.attr('href').substring(1));
            }
        },
    }
});
